import moment from "moment";

const HOUR = 60 * 60 * 1000;
const parseTime = (value) => {
  if (typeof value !== "string") return null;
  const match = value.trim().match(/^(\d{1,2}):([0-5]\d)(?::([0-5]\d))?$/);
  if (!match || Number(match[1]) > 23) return null;
  return (Number(match[1]) * 3600 + Number(match[2]) * 60 + Number(match[3] || 0)) * 1000;
};

const scheduleDuration = (schedule) => {
  if (!schedule) return null;
  let duration = 0;
  let hasRange = false;
  for (const [entry, exit] of [
    ["timeEnterMorning", "timeExitMorning"],
    ["timeEnterAfternoon", "timeExitAfternoon"],
  ]) {
    if (!schedule[entry] && !schedule[exit]) continue;
    const start = parseTime(schedule[entry]);
    const end = parseTime(schedule[exit]);
    if (start === null || end === null || end <= start) return parseTime(schedule.workHours);
    duration += end - start;
    hasRange = true;
  }
  // Los tramos son la fuente editable; workHours puede estar desactualizado.
  return hasRange ? duration : parseTime(schedule.workHours);
};

export const getEstimatedWorkMilliseconds = (date, schedule = null) => {
  const day = moment(date, "DD/MM/YYYY", true);
  if (!day.isValid()) return 0;

  const summerStart = day.clone().month(6).date(1).startOf("day");
  const summerEnd = day.clone().month(8).date(30).endOf("day");
  const reducedDay = day.day() === 5 || day.isBetween(summerStart, summerEnd, undefined, "[]");
  const duration = scheduleDuration(schedule);
  if (duration !== null) {
    const weekday = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"][day.day()];
    // El viernes no se convierte en jornada cero por el flag fri heredado.
    if (day.day() !== 5 && schedule?.[weekday] === false) return 0;
    return reducedDay ? Math.min(duration, 7 * HOUR) : duration;
  }

  return (reducedDay ? 7 : 8.5) * HOUR;
};
